import { render } from "./ViolationDetail.vue?vue&type=template&id=3bd1f9fe"
import script from "./ViolationDetail.vue?vue&type=script&lang=js"
export * from "./ViolationDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__